import { getField } from 'vuex-map-fields';

export const getters = {
  
  formattedVersions: (state) => {
    if (!state.surveyVersions) {
      return []
    }
    return state.surveyVersions.map((version) => ({
      id: version.id,
      version: version.version,
    })).reverse()
  },
  formEntryTitles: (state) => {
    // get all the questions in a form.  Exclude any with no properties as these should be just titles
    const elems = state.currentSurvey.current_version.elements
    const toReturn = elems
      .filter((elem) => elem.properties)
      .map((elem) => {
        let value
        elem.properties.forEach((prop) => {
          if (prop.key === 'label' && prop.value !== null) {
            ;({ value } = prop)
          }
        })
        return { id: elem.id, value }
      })
    return toReturn.filter((item) => item.value).sort((a, b) => a.id - b.id)
  },
  formattedSubmissions: (state) => {
  console.log("TCL:  ~ file: getters.js ~ line 31 ~ state", state)
    const responses = state.surveySubmissions
    const toReturn = responses.map((resp) => {
      const answers = JSON.parse(resp.data)

      const returnObj = {
        dateSubmitted: dayjs(resp.created_time).format('DD/MM/YYYY HH:mm'),
        user: {
          id: resp.user_id,
          name: resp.user_id,
        },
        answers: [],
      }
      const answerArray = []
      Object.keys(answers).forEach((answerTitle) => {
        const titleBits = answerTitle.split('_')

        // try to format the answers
        const originalAnswer = answers[answerTitle]
        let formattedAnswer = originalAnswer

        // are we a date?
        const dateRegex = /\d{4}-\d{1,2}-\d{1,2}/gm

        if (dateRegex.test(originalAnswer)) {
          formattedAnswer = dayjs(originalAnswer).format('DD/MM/YYYY')
        }

        // are we an object or array?
        if (['object', 'array'].includes(typeof originalAnswer)) {
          if (originalAnswer[0].value) {
            formattedAnswer = originalAnswer
              .map((item) => item.value)
              .join(', ')
          } else {
            formattedAnswer = originalAnswer.join(', ')
          }
        }

        // if (originalAnswer)
        answerArray.push({
          id: titleBits[1],
          question: titleBits[0],
          answer: formattedAnswer,
        })
      })

      returnObj.answers = answerArray.sort((a, b) => a.id - b.id)

      return returnObj
    })
    return toReturn
  },
  survey: (state) => state.currentSurvey,

  dataLoaded(state) {
    return !!state.survey
  },

  versions: (state) => {
    const versions = state.surveyVersions
    const filtered = versions.filter((vers) => {
      if (vers.version !== state.currentSurvey.current_version_id) {
        return vers
      }
      return null
    })
    return filtered.sort((a, b) => b.id - a.id)
  },

  getField,
};
